<template>
  <div class="mt-4">
    <fragment>
      <page-head
        small
        :back-route-path="'/bankruptcy'"
        show-back
        :back-text="local.common.return"
        class="page-head"
      >
        <div class="head-wings">
          <div
            v-show="$vuetify.breakpoint.lgAndUp"
            class="pr-16"
          >
            <p
              v-if="formModel.mainRequest"
              class="wing-1"
            >
              {{ pageHeaderTitle }}

              <span
                :class="{'status-ok': formModel.mainRequest.requestStep !== mainRequestStep.rejected,'status-rejected' :formModel.mainRequest.requestStep === mainRequestStep.rejected}"
                class="px-2"
              >
                <v-icon
                  small
                  :class="{'status-ok': formModel.mainRequest.requestStep !== mainRequestStep.rejected,'status-rejected' :formModel.mainRequest.requestStep === mainRequestStep.rejected}"
                >
                  mdi-circle
                </v-icon>
                <span class="statusName">
                  {{ formModel.mainRequest.requestStatusName }}
                </span>
              </span>
              <br>
              <span>
                {{ formModel.requestTypeName }}
              </span>
            </p>
          </div>

          <div :class="['wing r-info']">
            <p
              v-if="formModel.mainRequest"
              class="wing-2"
            >
              <span class="px-2"> {{ local.bankruptcy.bankruptcyFile.requestCode }} {{ formModel.mainRequest.code }}</span>
              <span class="px-2"> {{ local.bankruptcy.bankruptcyFile.requestDate }} {{ toGeorgianDateString( formModel.mainRequest.creationDate) }}</span>
            </p>
          </div>
        </div>
      </page-head>

      <page-content
        small
        class="content-box"
      >
        <div class="content-border row">
          <div class="col-2 tabs-box">
            <div class="attribute-item">
              {{ local.bankruptcy.bankruptcyFile.subRequestCode }}
              <br>
              {{ formModel.subRequestCode }}
            </div>

            <div>
              <naj-button
                text
                class="back"
                @click="goToMainRequest()"
              >
                <v-icon class="blackText">
                  mdi-arrow-right
                </v-icon>
                <span class="textBack blackText">
                  {{ local.common.returnToMainRequest }}
                </span>
              </naj-button>
            </div>
            <div>
              <v-tabs
                v-model="tab"
                vertical
                hide-slider
              >
                <v-tab
                  v-for="navTab in tabs"
                  :key="navTab.href"
                  :disabled="navTab.disabled"
                  :href="navTab.href"
                  class="tab-button"
                  active-class="tab-active"
                >
                  <v-icon
                    left
                    class="tab-button-icon"
                  >
                    {{ navTab.icon }}
                  </v-icon>
                  <span class=" mr-1"> {{ navTab.title }}</span>
                </v-tab>
              </v-tabs>
            </div>
          </div>

          <div class="col-10 p-2 tabs-section">
            <div v-if="formModel.mainRequest">
              <sub-request-summary :request-info="formModel"></sub-request-summary>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-if="tab == 'tab-1'"
                  value="tab-1"
                >
                  <request-detail :request-info="formModel"></request-detail>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-2'"
                  value="tab-2"
                >
                  <sessions-tab :request-info="formModel"></sessions-tab>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-3'"
                  value="tab-3"
                >
                  <judgements-tab
                    :request-info="formModel"
                    :show-new-request="showNewRequest"
                  >
                  </judgements-tab>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-4' && formModel.requestTypeId != subRequestType.VerdictObjectionRequest"
                  value="tab-4"
                >
                  <requests-tab
                    :request-info="formModel"
                    :show-new-request="showNewRequest"
                  ></requests-tab>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-5'"
                  value="tab-5"
                >
                  <decisions-tab :request-info="formModel"></decisions-tab>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-6'"
                  value="tab-6"
                >
                  <attachments-tab :request-info="formModel"></attachments-tab>
                </v-tab-item>
                <v-tab-item
                  v-if="tab == 'tab-7'"
                  value="tab-7"
                >
                  <deposits-tab :request-info="formModel"></deposits-tab>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </div>
      </page-content>
    </fragment>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import { mode, userType } from '@/helpers/enum';
import { toGeorgianDateString } from '@/helpers/utils';
import { subRequestTypesEnum, mainRequestStep, subRequestType, subRequestCircleActions } from '@/modules/bankruptcy/helpers/enum';
import RequestDetail from './sub-request-details.vue';
import SubRequestSummary from './sub-request-summary.vue';
const { mapActions: mapBankruptcyActions, mapState: mapBankruptcyState } = createNamespacedHelpers('BankruptcyModule');
import SessionsTab from './sessions-tab/index';
import JudgementsTab from './judgements-tab/index';
import RequestsTab from './requests-tab/index';
import DecisionsTab from './decisions-tab/index';
import AttachmentsTab from './attachments-tab/index';
import DepositsTab from './deposits-tab/index';

export default {
  components: {
    RequestDetail,
    SessionsTab,
    SubRequestSummary,
    JudgementsTab,
    RequestsTab,
    DecisionsTab,
    AttachmentsTab,
    DepositsTab,
  },
  data() {
    return {
      mode,
      subRequestType,
      userType,
      request: {},
      loading: false,
      RequestTypes: subRequestTypesEnum,
      requestCustomData: null,
      formModel: {
        reasons: [],
        attachments: [],
        requestCustomData: {},
      },
      mainRequestStep,
      toGeorgianDateString,
      tab: {},
      showNewRequest: false,
      subRequestCircleActions,
    };
  },
  computed: {
    ...mapBankruptcyState([
      'attachmentTypes',
      'currentUser',
    ]),
    requestType() {
      return this.RequestTypes[this.$route.params.requestType] || {};
    },
    pageHeaderTitle() {
      if (this.formModel.mainRequest) {
        return `${this.local.bankruptcy.bankruptcyFile.request} ${this.formModel.mainRequest.requestCategoryName} ${this.formModel.mainRequest.procedureName}`;
      }
      return '..';
    },
    isAllowedObjectionRequest() {
      return this.formModel.requestTypeId != this.subRequestType.VerdictObjectionRequest;
    },
    tabs() {
      return [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.bankruptcyFile.basicInfo.tabTitle,
          icon: 'mdi-file-table',
          disabled: false,
          isEnabled: true,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.bankruptcyFile.sessions.tabTitle,
          icon: 'mdi-account-group',
          disabled: false,
          isEnabled: true,
        },
        {
          href: '#tab-3',
          title: this.local.bankruptcy.bankruptcyFile.judgements.tabTitle,
          icon: 'mdi-gavel',
          disabled: false,
          isEnabled: true,
        },
        {
          href: '#tab-4',
          title: this.local.bankruptcy.bankruptcyFile.objectionRequests.tabTitle,
          icon: 'mdi-archive',
          isEnabled: this.isAllowedObjectionRequest,
        },
        {
          href: '#tab-5',
          title: this.local.bankruptcy.bankruptcyFile.decisions.tabTitle,
          icon: 'mdi-bookshelf',
          disabled: false,
          isEnabled: true,
        },
        {
          href: '#tab-6',
          title: this.local.bankruptcy.bankruptcyFile.attachments.tabTitle,
          icon: 'mdi-file-document',
          disabled: false,
          isEnabled: false,
        },
        {
          href: '#tab-7',
          title: this.local.bankruptcy.bankruptcyFile.deposits.tabTitle,
          icon: 'mdi-bookshelf',
          disabled: false,
          isEnabled: this.formModel.circleActionId == subRequestCircleActions.deposit,
        },
      ].filter(t => t.isEnabled);
    },
  },
  watch: {},
  mounted() {
    this.openSubRequest();
  },
  methods: {
    ...mapBankruptcyActions([
      'mainRequestInquiry',
      'getRelatedRequest',
      'getDebtorsDetails',
      'checkHasAccessToMainRequest',
      'checkHasAccessToSubRequest',
      'getBankruptcyUserInfo',
    ]),
    goToMainRequest() {
      this.loading = true;
      this.checkHasAccessToMainRequest(this.$route.params.mainRequestObjectKey)
        .then((res) => {
          if (res.data) {
            this.$router.push({ path: `/bankruptcy/bankruptcy-file/${this.formModel.mainRequestObjectKey}` });
          }
          else {
            this.toaster.error(this.local.errorPages.forbidden.title);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openSubRequest() {
      this.loading = true;
      const subRequestObjectKey = this.$route.params.subRequestObjectKey;
      this.checkHasAccessToSubRequest(subRequestObjectKey)
        .then((res) => {
          if (res.data) {
            this.getData();
          }
          else {
            this.toaster.error(this.local.errorPages.forbidden.title);
            this.$router.push({ path: `/bankruptcy` });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      const subRequestObjectKey = this.$route.params.subRequestObjectKey;
      this.loading = true;
      const searchQuery = { mainRequestObjectKey: this.$route.params.mainRequestObjectKey };
      Promise.all([
        this.mainRequestInquiry(searchQuery),
        this.getRelatedRequest(subRequestObjectKey),
        this.getDebtorsDetails(this.$route.params.mainRequestObjectKey),
        this.getBankruptcyUserInfo(),
      ]).then((data) => {
        const formModel = data[1].data;
        formModel.mainRequest = data[0].data;
        // in edit mode attorney is disabled and verified
        formModel.requestApplicant.isAttorneyVerified = !!formModel.requestApplicant.attorneyNumber;
        formModel.requestApplicant.debtor = data[2].data;
        formModel.mode = mode.view;
        this.$set(this, 'request', formModel);
        this.$set(this, 'formModel', formModel);

        this.showNewRequest = this.isAllowedObjectionRequest && (this.currentUser.isIndividualUser || this.currentUser.loginType == 'governmental' || this.currentUser.loginType == 'lawyers');

      })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.statusName {
  font-size: 14px;
}
.status-rejected {
  color: #f44336 !important;
}

.status-ok {
  color: #29af5b;
}
.head-wings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  .r-info {
    margin-left: 40px;
  }
}
.page-head {
  box-shadow: none !important;
  background: #fff !important;
}
.wing-1 {
  font-weight: 1000;
  font-size: 18px;
  padding-right: 80px;
}
.wing-2 {
  font-weight: bolder;
  font-size: 14px;
}
.content-box {
  padding: 0px !important;
  margin-top: 0px !important;
}
.content-border {
  border: 35px solid #faf9f4 !important;
}
.tabs-box {
  padding: 0;
  background: #faf9f4;
  .tab-button {
    font: normal normal normal 16px/24px Almarai;
    justify-content: right;
    background: #faf9f4;
    &.tab-active {
      font-weight: bold;
      color: #158e8d;
    }
  }
}
.tabs-section {
  min-height: 600px;
}
#dd span {
  width: 200px;
  border-bottom: 1px dashed #158e8d;
  display: inline-block;
}
.vertical_dashed_line {
  border-right: 1px dashed #158e8d;
  height: 500px;
}

.attribute-item {
  font-size: 14px;
  font-weight: bold;
  color: #02363d;
}
.back {
  border-bottom: 1px solid;
  color: #83aea8;
  .textBack {
    font-size: 14px !important;
  }
  .blackText {
    color: black;
  }
}
</style>
